/**
 * Expose a single entry point where both the client and server can use
 */
export const config = {
  analytics: {
    affiliate: { MARKETPLACE_URL: process.env.MARKETPLACE_URL },
    intercom: {
      APP_ID: process.env.INTERCOM_APP_ID,
      SECRET: process.env.INTERCOM_SECRET
    },
    newrelic: {
      ENABLED: process.env.NEW_RELIC_ENABLED,
      LICENSE_KEY: process.env.NEW_RELIC_LICENSE_KEY
    },
    rollbar: {
      CLIENT_SIDE_TOKEN: process.env.ROLLBAR_CLIENT_SIDE_TOKEN,
      SERVER_SIDE_TOKEN: process.env.ROLLBAR_SERVER_SIDE_TOKEN
    },
    cookiebot: { COOKIEBOT_ID: process.env.COOKIEBOT_ID }
  },
  assets: { PUBLIC_PATH: process.env.PUBLIC_PATH },
  cache: { DISABLE_CACHE: process.env.DISABLE_CACHE },
  cors: {
    WHITELIST: process.env.CORS_WHITELIST
      ? (process.env.CORS_WHITELIST || '').split(',')
      : []
  },
  datadog: {
    HOST: process.env.DATADOG_HOST || 'localhost',
    PORT: process.env.DATADOG_PORT || '8125'
  },
  db: { REDIS_URL: process.env.REDIS_URL },
  discoveryUser: {
    PUBLIC_SEARCH_API_URL: process.env.PUBLIC_SEARCH_API_URL,
    RECOMMENDATION_API_URL: process.env.RECOMMENDATION_API_URL
  },
  eventsApi: { URL: process.env.EVENTS_API_URL },
  experimentsApi: { URL: process.env.EXPERIMENTS_API_URL },
  jwt: {
    PUBLIC_KEY: process.env.JWT_PUBLIC_KEY,
    WEBSITES_MARKETPLACE_PUBLIC_KEY:
      process.env.WEBSITES_MARKETPLACE_PUBLIC_KEY,
    MARKETPLACE_PUBLIC_KEY: process.env.MARKETPLACE_PUBLIC_KEY
  },
  marketplaceApi: {
    SECRET: process.env.X_ENVATO_SECRET,
    URL: process.env.MARKETPLACE_API_URL
  },
  sso: {
    RECAPTCHA_KEY: process.env.RECAPTCHA_KEY,
    SERVER_HOST: process.env.SSO_SERVER_HOST
  },
  HOMEPAGE_JSON_BUCKET_URL: process.env.HOMEPAGE_JSON_BUCKET_URL,
  HOMEPAGE_JSON_CDN_URL: process.env.HOMEPAGE_JSON_CDN_URL
}
